// extracted by mini-css-extract-plugin
module.exports = {"root":"LinksMobile-module--root--2UqdK","links":"LinksMobile-module--links--1K5zD","link":"LinksMobile-module--link--2y1-b","logo":"LinksMobile-module--logo--16wjw"};